import React, { useEffect, useState } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Row, Col, Button, Form, Modal, TreeSelect } from '../../ui/ot'
import DepartmentRole from './DepartmentRole';

const { confirm } = Modal;
const RoleDepartment = ({
    propsForm,
    field,
    remove,
    defaultDepartment,
    defaultRole,
    showMode,    //可供呈現一個結構體
    onDepartmentRoleChange = () => { },
    ...props
}) => {
    const [form_] = Form.useForm();
    const form = propsForm ?? form_
    const [count, setCount] = useState(0);
    const [departmentData, setDepartmentData] = useState([]);
    const [roleData, setRoleData] = useState([]);
    const [departmentOption, setDepartmentOption] = useState([]);
    const [roleOption, setRoleOption] = useState([]);
    const [departmentId, setDepartmentId] = useState(defaultDepartment);
    const [roleId, setRoleId] = useState(defaultRole);
    const [departmentRoleData, setDepartmentRoleData] = useState([])
    const getDepartmentData = () => {
        axios
            .get('/organization_structure/api/department', {
                params: {
                    classify_structure_type_id: 0,
                    classify_structure_id: 9
                }
            })
            .then((response) => {
                setDepartmentData(response.data.data)
            })
    }
    const getDepartmentOption = () => {
        axios
            .get('/organization_structure/api/department', {
                params: {
                }
            })
            .then((response) => {
                setDepartmentOption(response.data.data)
            })
    }
    const getRoleOption = () => {
        axios
            .get('/organization_structure/api/role', {
                params: {
                }
            })
            .then((response) => {
                setRoleOption(response.data.data)
            })
    }
    const getRoleData = () => {
        axios
            .get('/organization_structure/api/role', {
                params: {
                    // classify_structure_type_id_for_department: departmentId,
                    classify_structure_type_id: 0,
                    classify_structure_id: 8
                }
            })
            .then((response) => {
                setRoleData(response.data.data?.map(role => {
                    return {
                        ...role,
                        title: role?.role_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem =>
                            itemItemItem?.language_culture_value
                        )
                    }
                }))
            })
    }
    const changeDepartmentRole = (departmentRoleDataTemp) => {
        let departmentRoleDataResult = []
        // setDepartmentRoleData(
        departmentRoleDataResult = departmentRoleDataTemp.map((item, index) => {
            let departmentId = 0
            let roleId = 0
            departmentOption.map((departmentDataItem, i) => {
                if (departmentDataItem.classify_structure_type_id === item.department_classify_structure_type_id) {
                    departmentId = departmentDataItem.department_id
                }
            })
            form.setFieldValue(
                [field.name, 'user_role_department_data'].join('.'), []
            )
            roleOption.map((roleDataItem, ii) => {
                if (String(roleDataItem.classify_structure_type_id) === String(item.role_classify_structure_type_id)) {
                    roleId = roleDataItem.role_id
                    setDepartmentRoleData(roleDataItem?.department_role_data)
                    form.setFieldValue(
                        [field.name, 'user_role_department_data'].join('.'), Array(roleDataItem?.department_role_data.length).fill({})
                    )
                }
            })
            return (
                {
                    department_id: departmentId,
                    role_id: roleId
                }
            )
        })
        return departmentRoleDataResult;
    }
    useEffect(() => {
        getDepartmentData()
        getDepartmentOption()
        getRoleOption()
        getRoleData()
    }, []);
    useEffect(() => {
        if (departmentData.length !== 0 && defaultDepartment) {
            setDepartmentId(defaultDepartment)
        }
    }, [departmentData]);
    useEffect(() => {
        if (roleData.length !== 0 && defaultRole) {
            setRoleId(defaultRole)
        }
    }, [roleData]);

    useEffect(() => {
        let departmentRoleData = []
        if (departmentId | roleId) {
            departmentRoleData = changeDepartmentRole([
                {
                    department_classify_structure_type_id: departmentId,
                    role_classify_structure_type_id: roleId
                }
            ])
            onDepartmentRoleChange(departmentRoleData)
        }
    }, [departmentId, roleId])

    useEffect(() => {
        setTimeout(() => {
            setCount(pre => pre + 1)
        }, 1000)
    }, [])

    return (

        <Row gutter={[4, 4]} style={{ display: 'flex', justify: 'center', alignItems: 'center' }}>

            <Col span={20}>
                {roleData.length !== 0 && (showMode === undefined || showMode === 'role') && <Form.Item

                    label={"角色"}
                    name={[field.name, 'role_classify_structure_type_id']}
                    rules={[
                        {
                            required: true,
                            message: `此為必填項目`
                        }
                    ]}
                >
                    <TreeSelect
                        // defaultValue={
                        //     roleId
                        // }
                        showSearch
                        style={{
                            width: '100%',
                        }}
                        dropdownStyle={{
                            maxHeight: 400,
                            overflow: 'auto',
                        }}
                        placeholder="選擇角色"
                        allowClear
                        treeDefaultExpandAll
                        treeNodeFilterProp={"title"}
                        onChange={
                            (e) => {
                                setRoleId(e.target.value)
                            }
                        }
                        treeData={roleData}
                    />
                </Form.Item>
                }
                {departmentData.length !== 0 && (showMode === undefined || showMode === 'department') && <>
                    {!props.edit &&
                        <Form.List
                            key={count}
                            label={"角色"}
                            name={[field.name, "user_role_department_data"]}
                            rules={[
                                {
                                    required: true,
                                    message: `此為必填項目`
                                }
                            ]}
                        >
                            {(subFields, { add, remove }) => (
                                <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'end' }}>
                                    {subFields?.map((subField, key) => (<>
                                        <Col span={24}>
                                            <Form.Item
                                                label={`${departmentRoleData?.[key]?.department_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem =>
                                                    itemItemItem?.language_culture_value
                                                )}${key + 1}`}
                                                name=""
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: `此為必填項目`
                                                    }
                                                ]}
                                            >
                                                <DepartmentRole
                                                    // key={field.id}
                                                    departmentPlaceholder={'選擇' + departmentRoleData?.[key]?.department_language_data?.filter(itemItemItem => itemItemItem.language_culture_code === "zh-tw").map(itemItemItem =>
                                                        itemItemItem?.language_culture_value
                                                    )}
                                                    showMode={'department'}
                                                    showLabel={false}
                                                    field={subField}
                                                    defaultDepartment={form.getFieldValue([subField.name, "department_classify_structure_type_id"])}
                                                    propsDepartmentClassifyStructureTypeId={departmentRoleData?.[key]?.classify_structure_type_id}
                                                ></DepartmentRole>
                                            </Form.Item>
                                        </Col>
                                    </>))}
                                </Row>
                            )}
                        </Form.List>
                    }
                </>}
            </Col>
            <Col span={4}>
                <Button
                    onClick={() => {
                        confirm({
                            title: '確定要刪除嗎',
                            icon: <ExclamationCircleOutlined />,
                            okText: '確定',
                            okType: 'danger',
                            cancelText: '取消',
                            onOk() {
                                remove(field.name);
                            },
                            centered: true
                        });
                    }}> 刪除角色
                </Button>
            </Col>
        </Row>

    )
}
export default RoleDepartment;

